import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

// @param scheduleData: object
// {
//   "is_active": false
// }
export function createStudentSchedule(studentId: number,scheduleData: object): Promise<ApiResponse> {
  return Axios.post(`v1/liaisons/students/${studentId}/schedule`, scheduleData);
}

// @param scheduleData: object
// {
//   "is_active": false
// }
export function updateStudentSchedule(studentId: number,scheduleData: object): Promise<ApiResponse> {
  return Axios.put(`v1/liaisons/students/${studentId}/schedule`, scheduleData);
}